import { minutesToDurationText } from "../ClassTemplateWizard/duration";

export const sessionCountLabel = (count) => `${count} ${count === 1 ? "session" : "sessions"}`;

export function templateLength(sessionsCount, sessionMinutes) {
  const count = sessionsCount || 0;
  if (count === 0) return "No sessions yet";
  if (!sessionMinutes) return sessionCountLabel(count);
  const total = minutesToDurationText(count * sessionMinutes);
  return `${sessionCountLabel(count)} · ${total}${count > 1 ? " total" : ""}`;
}

export function sessionLengthLabel(sessionsCount, sessionMinutes) {
  const count = sessionsCount || 0;
  if (!sessionMinutes) return count ? sessionCountLabel(count) : null;
  const each = minutesToDurationText(sessionMinutes);
  if (count === 0) return `${each} per session`;
  return `${sessionCountLabel(count)}, ${each}${count > 1 ? " each" : ""}`;
}
